const BASE_CONST = 'REPORTS_TRANSACTIONS'

/********************************************************************************
 * Transactions related
 ********************************************************************************/

export const REPORTS_TRANSACTIONS_PAGE_REQUEST = `${BASE_CONST}_PAGE_REQUEST`
export const REPORTS_TRANSACTIONS_TRANSACTIONS_REQUEST = `${BASE_CONST}_TRANSACTIONS_REQUEST`
export const REPORTS_TRANSACTIONS_SET_TRANSACTIONS = `${BASE_CONST}_SET_TRANSACTIONS`

/********************************************************************************
 * End transactions related
 ********************************************************************************/

/********************************************************************************
 * Change Related
 ********************************************************************************/
export const REPORTS_TRANSACTIONS_CHANGE_OUTLET = `${BASE_CONST}_CHANGE_OUTLET`
export const REPORTS_TRANSACTIONS_CHANGE_DATE = `${BASE_CONST}_CHANGE_DATE`
export const REPORTS_TRANSACTIONS_CHANGE_KEYWORD = `${BASE_CONST}_CHANGE_KEYWORD`
/********************************************************************************
 * End Change Related
 ********************************************************************************/

/********************************************************************************
 * Transaction Detail Related
 ********************************************************************************/
export const REPORTS_TRANSACTIONS_HIDE_TRANSACTION_DETAIL = `${BASE_CONST}_HIDE_TRANSACTION_DETAIL`
export const REPORTS_TRANSACTIONS_SET_TRANSACTION_DETAIL = `${BASE_CONST}_SET_TRANSACTION_DETAIL`
export const REPORTS_TRANSACTIONS_TRANSACTION_DETAIL_REQUEST_NON_MOBILE = `${BASE_CONST}_TRANSACTION_DETAIL_REQUEST_NON_MOBILE`
export const REPORTS_TRANSACTIONS_TRANSACTION_DETAIL_REQUEST_MOBILE = `${BASE_CONST}_TRANSACTION_DETAIL_REQUEST_MOBILE`
export const REPORTS_TRANSACTIONS_SHOW_TRANSACTION_DETAIL_MODAL = `${BASE_CONST}_SHOW_TRANSACTION_DETAIL_MODAL`
export const REPORTS_TRANSACTIONS_HIDE_TRANSACTION_DETAIL_MODAL = `${BASE_CONST}_HIDE_TRANSACTION_DETAIL_MODAL`

/********************************************************************************
 * Resend Email Related
 ********************************************************************************/
export const REPORTS_TRANSACTIONS_SEND_EMAIL_RECEIPT = `${BASE_CONST}_SEND_EMAIL_RECEIPT`
export const REPORTS_TRANSACTIONS_SHOW_RESEND_EMAIL_MODAL = `${BASE_CONST}_SHOW_RESEND_EMAIL_MODAL`
export const REPORTS_TRANSACTIONS_HIDE_RESEND_EMAIL_MODAL = `${BASE_CONST}_HIDE_RESEND_EMAIL_MODAL`
export const REPORTS_TRANSACTIONS_CANCEL_RESEND_EMAIL = `${BASE_CONST}_CANCEL_RESEND_EMAIL`
/********************************************************************************
 * End Resend Email Related
 ********************************************************************************/

/********************************************************************************
 * Refund Breakdown Modal Related
 ********************************************************************************/
export const REPORTS_TRANSACTIONS_SHOW_REFUND_BREAKDOWN_MODAL = `${BASE_CONST}_SHOW_REFUND_BREAKDOWN_MODAL`
export const REPORTS_TRANSACTIONS_HIDE_REFUND_BREAKDOWN_MODAL = `${BASE_CONST}_HIDE_REFUND_BREAKDOWN_MODAL`

export const REPORTS_TRANSACTIONS_REFUND_BREAKDOWN_SET_REFUND_ITEMS = `${BASE_CONST}_REFUND_BREAKDOWN_SET_REFUND_ITEMS`

export const REPORTS_TRANSACTIONS_REFUND_BREAKDOWN_SET_REFUND_ITEMS_PROMO = `${BASE_CONST}_REFUND_BREAKDOWN_SET_REFUND_ITEMS_PROMO`

export const REPORTS_TRANSACTIONS_ISSUE_REFUND_REQUEST = `${BASE_CONST}_REFUND_BREAKDOWN_ISSUE_REFUND_REQUEST`

export const REPORTS_TRANSACTIONS_SHOW_SET_QUANTITY_MODAL = `${BASE_CONST}_SHOW_SET_QUANTITY_MODAL`

export const REPORTS_TRANSACTIONS_HIDE_SET_QUANTITY_MODAL = `${BASE_CONST}_HIDE_SET_QUANTITY_MODAL`

export const REPORTS_TRANSACTIONS_ASK_SET_QUANTITY = `${BASE_CONST}_ASK_SET_QUANTITY`

export const REPORTS_TRANSACTIONS_CONFIRM_SET_QUANTITY = `${BASE_CONST}_CONFIRM_SET_QUANTITY`

export const REPORTS_TRANSACTIONS_CANCEL_SET_QUANTITY = `${BASE_CONST}_CANCEL_SET_QUANTITY`

/********************************************************************************
 * End Refund Breakdown Modal Related
 ********************************************************************************/

/********************************************************************************
 * Old Refund Modal Related
 ********************************************************************************/
export const REPORTS_TRANSACTIONS_SHOW_OLD_REFUND_MODAL = `${BASE_CONST}_SHOW_OLD_REFUND_MODAL`
export const REPORTS_TRANSACTIONS_HIDE_OLD_REFUND_MODAL = `${BASE_CONST}_HIDE_OLD_REFUND_MODAL`

export const REPORTS_TRANSACTIONS_ISSUE_OLD_REFUND_REQUEST = `${BASE_CONST}_ISSUE_OLD_REFUND_ISSUE_REQUEST`

/********************************************************************************
 * End Old Refund Modal Related
 ********************************************************************************/

/********************************************************************************
 * Export Transaction Related
 ********************************************************************************/

export const REPORTS_TRANSACTIONS_EXPORT_TRANSACTION = `${BASE_CONST}_EXPORT_TRANSACTION`

/********************************************************************************
 * End Export Transaction Related
 ********************************************************************************/

export const REPORTS_TRANSACTIONS_SET_OUTLETS = `${BASE_CONST}_SET_OUTLETS`

export const REPORTS_TRANSACTIONS_CANCEL_REFUND_BREAKDOWN = `${BASE_CONST}_CANCEL_REFUND_BREAKDOWN`

export const REPORTS_TRANSACTIONS_SHOW_LOADING_SPINNER = `${BASE_CONST}_SHOW_LOADING_SPINNER`



// WEBPACK FOOTER //
// ./app/actions/reports/transactions/constants.js